export default __webpack_public_path__ + "static/media/0077BLEU.2941250c.pdf";